// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__6Yuby"};